const adminRoutes = [
  {
    path: '/admin/',
    redirect: { name: 'super-admin-tenants' },
    meta: { layout: 'admin', superAdmin: true }
  },
  {
    path: '/admin/tenants',
    name: 'super-admin-tenants',
    component: () =>
      import(
        /* webpackChunkName: "super-admin-tenants" */ '@/views/super-admin/TenantPanel.vue'
      ),
    meta: {
      layout: 'admin',
      superAdmin: true,
      pageTitle: 'Tenant Administration'
    }
  },
  {
    path: '/admin/cloudflare',
    name: 'super-admin-cloudflare',
    component: () =>
      import(
        /* webpackChunkName: "super-admin-cloudflare" */ '@/views/super-admin/CloudflareConfiguration.vue'
      ),
    meta: {
      layout: 'admin',
      superAdmin: true,
      pageTitle: 'Cloudflare Configuration'
    }
  },
  {
    path: '/admin/carrier-social',
    name: 'super-admin-carrier-social',
    component: () =>
      import(
        /* webpackChunkName: "super-admin-carrier-social" */ '@/views/super-admin/SocialConfiguration.vue'
      ),
    meta: {
      layout: 'admin',
      superAdmin: true,
      pageTitle: 'Carrier Social Config'
    }
  }
];

export default adminRoutes;
